export default __webpack_public_path__ + "static/media/close-light.eebce143.svg";